
import { defineComponent, onMounted } from 'vue'
import UIkit from 'uikit'
import { uploadImageUrl, withCredentials } from '@/api_client'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import { convertSnakeToCamel } from '@/utils/useSimpleTransformations'
import { notify } from '@/utils/useNotifications'

export default defineComponent({
  props: {
    title: { type: String, required: true }
  },
  emits: ['filesUploaded'],
  setup(props, { emit }) {
    const { useActions } = createNamespacedHelpers('images')
    const { uploadedImage } = useActions(['uploadedImage'])

    const customUploadHandler = (e) => {
      e.target.__uikit__.upload.params = { title: props.title }
    }

    interface UploadEnvironmentInterface {
      headers: object
      total: number
      loaded: number
      xhr: { withCredentials: boolean }
    }
    interface BarHTMLElement extends HTMLElement {
      max: number
      value: number
    }

    onMounted(() => {
      const bar = document.getElementById('js-progressbar') as BarHTMLElement

      UIkit.upload('.js-upload', {
        url: uploadImageUrl,
        multiple: false,
        name: 'file',
        mime: 'image/*',
        params: {
          title: props.title
        },
        beforeSend(e: UploadEnvironmentInterface) {
          e.xhr.withCredentials = withCredentials
        },
        error(err) {
          const response = JSON.parse(err.xhr.response)
          notify(response.errors, 'danger')
        },
        loadStart(e: UploadEnvironmentInterface) {
          if (!bar) return

          bar.removeAttribute('hidden')
          bar.max = e.total
          bar.value = e.loaded
        },
        progress(e: UploadEnvironmentInterface) {
          if (!bar) return

          bar.max = e.total
          bar.value = e.loaded
        },
        loadEnd(e: UploadEnvironmentInterface) {
          if (!bar) return

          bar.max = e.total
          bar.value = e.loaded
        },
        completeAll() {
          let response = JSON.parse(arguments[0].response)
          response = convertSnakeToCamel(response)
          uploadedImage(response)

          if (bar)
            setTimeout(() => {
              bar.setAttribute('hidden', 'hidden')
            }, 1000)

          notify('Image successfully uploaded', 'success')
          emit('filesUploaded')
        }
      } as UIkit.UIkitUploadOptions)
    })

    return { customUploadHandler }
  }
})
